module.exports = {"audiences":["newAndNeededConfirmationAndNoTeams"],"autoTrack":true,"experimentAllocation":0,"defaultWeight":1,"experimentVersion":"v2","defaults":{"enabled":false},"audienceSettings":{"startDate":"2018-05-03"},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/confirmDuringSignup.json
// module id = BSp5
// module chunks = 1